import ProductCode from './ProductCode';
import { formatPrice } from '../helpers/misc';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from '@mui/material';


const COLUMNS = [
    { label: 'QTY', align: 'right' },
    { label: 'PRODUCT CODE' },
    { label: 'PRODUCT DESCRIPTION' },
    { label: 'PRICE / EA', align: 'right' },
    { label: 'AMOUNT', align: 'right' }
]

export default function DetailTable(props) {
    const { data=[] } = props;

    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label='invoice table'>
                <TableHead>
                    <TableRow sx={{ backgroundColor: 'primary.light' }}>
                        {COLUMNS.map(({ label, align }) =>
                            <TableCell
                                sx={{ fontWeight: 600 }}
                                key={label}
                                align={align}
                            >
                                {label}
                            </TableCell>)}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row, index) => (
                        <TableRow key={index}>
                            <TableCell align="right">{row.unit_count}</TableCell>
                            <TableCell>
                                <ProductCode
                                    productSku={row.source_product_id}
                                    odsProductId={row.ods_product_id}
                                />
                            </TableCell>
                            <TableCell>{row.line_description}</TableCell>
                            <TableCell align="right">{formatPrice(row.unit_price)}</TableCell>
                            <TableCell align="right">{formatPrice(row.total_amount)}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}